import { LogoMark } from './LogoMark';

/**
 * Lawsnote ヘッダー。
 * 既存サイトへ組み込む場合はこのコンポーネントを既存 Header に差し替える。
 */
export function Header() {
  return (
    <header className="border-b border-line bg-white">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-3.5">
        <a href="/" className="flex items-center gap-2.5" aria-label="Lawsnote Japan トップページ">
          <LogoMark size={32} />
          <span className="text-[17px] font-bold tracking-tight text-ink">
            Lawsnote <span className="text-brand">Japan</span>
          </span>
        </a>
      </div>
    </header>
  );
}
